/**
 * PROXY       : 代理地址
 * BASE_PATH   : 应用基础路径（同时作为打包输出目录名）
 * PUBLIC_PATH : 静态资源路径
 * IS_PROD     : 是否为生产环境
 */

let PROXY: string,
    PUBLIC_PATH: string,
    BASE: string,
    IS_PROD: boolean = false;


const BASE_PATH: string = 'bizops';

type ENV_TYPE = 'dev' | 'test' | 'prod';
const ENV = (process.env.REACT_APP_ENV || 'dev') as ENV_TYPE;

switch (ENV) {
  case 'prod':
    PROXY = 'https://erp.benhealthconsulting.com';
    PUBLIC_PATH = `//static.erp.benhealthconsulting.com/`;
    BASE = `/`;
    IS_PROD = true;
    break;

  case 'test':
    PROXY = 'https://staging.benhealth.com.cn';
    PUBLIC_PATH = `/${BASE_PATH}/`;
    BASE = `/${BASE_PATH}/`;
    IS_PROD = false;
    break;

  case 'dev':
    PROXY = 'http://192.168.20.7';
    PUBLIC_PATH = `/${BASE_PATH}/`;
    BASE = `/${BASE_PATH}/`;
    IS_PROD = false;

}

export { BASE_PATH, BASE, IS_PROD, PROXY, PUBLIC_PATH };
